import { STATIC_ASSETS_URL } from "common/context/constants"

export const USUARIO_ORIGEN_BDE = 1
export const BUZON_EMPRESAS_PRODUCT = "ERP"

export const SEARCH_PARAMS = {
  GOTO: "goto",
  REMESAS_COBRO: "create-remesas-cobro",
  REMESAS_PAGO: "create-remesas-pago",
  ASIENTO_CONTABLE: "create-asiento-contable",
  CUENTA_CONTABLE: "create-cuenta-contable",
  PAGO: "create-pago",
  COBRO: "create-cobro",
  CONTACTO: "create-contacto",
  ARTICULO: "create-articulo",
  CATALOGO: "create-catalogo",
  CUENTA_BANCARIA: "create-cuenta-bancaria",
  USUARIO: "create-usuario",
  DEPARTAMENTO: "create-departamento",
  PRESTAMO: "create-prestamo",
}

export const QUERY_PARAMETERS = {
  DesdeFechaActividad: "&DesdeFechaActividad",
  HastaFechaActividad: "&HastaFechaActividad",
  EstadoPotencialVenta: "&EstadoPotencialVenta",
  UsuarioAsignadoId: "&UsuarioAsignadoId",
  MaxResultCount: "?MaxResultCount",
  EtiquetaNombre: "&EtiquetaNombre",
  SortingCriteria: "&SortingCriteria",
  Descripcion: "&Descripcion",
  IndustriaId: "&IndustriaId",
  SkipCount: "&SkipCount",
  RangoNumeroEmpleados: "&RangoNumeroEmpleados",
  EmpresaGestionadaId: "&EmpresaGestionadaId",
  RazonSocial: "&RazonSocial",
  TipoNota: "&TipoNota",
  ambito: "&ambito",
  realizada: "&realizada",
  SinUsuarioAsignado: "&SinUsuarioAsignado",
  FechaEmisionLowerLimit: "&FechaEmisionLowerLimit",
  FechaEmisionUpperLimit: "&FechaEmisionUpperLimit",
  ImporteLowerLimit: "&ImporteLowerLimit",
  ImporteUpperLimit: "&ImporteUpperLimit",
  ImporteAmortizacionLowerLimit: "&ImporteAmortizacionLowerLimit",
  ImporteAmortizacionUpperLimit: "&ImporteAmortizacionUpperLimit",
  FechaInicio: "&FechaInicio",
  FechaFin: "&FechaFin",
  Estado: "&Estado",
  fechaOmision: "&fechaOmision",
  intervalo: "&intervalo",
  FechaLowerLimit: "&FechaLowerLimit",
  FechaUpperLimit: "&FechaUpperLimit",
  Estados: "&Estados",
  Keyword: "&Keyword",
  CuentaContableGrupo: "&CuentaContableGrupo",
  TipoInformeSumaSaldo: "&TipoInformeSumaSaldo",
  FechaInicioMovimiento: "&FechaInicioMovimiento",
  FechaFinMovimiento: "&FechaFinMovimiento",
  EsMensual: "&EsMensual",
  Tipo: "&Tipo",
  TipoPrestamo: "&TipoPrestamo",
  TieneDeuda: "&TieneDeuda",
  NoTieneDeuda: "&NoTieneDeuda",
  CreationUserIds: "&CreationUserIds",
  PendienteDePago: "&PendienteDePago",
  FechaFinAsiento: "&FechaFinAsiento",
  FechaInicioAsiento: "&FechaInicioAsiento",
  Punteados: "&Punteados",
  NoPunteados: "&NoPunteados",
  TipoAsiento: "&TipoAsiento",
  ImporteDebe: "&ImporteDebe",
  ImporteHaber: "&ImporteHaber",
  OperadorImporteDebe: "&OperadorImporteDebe",
  OperadorImporteHaber: "&OperadorImporteHaber",
  TieneMovimientos: "&TieneMovimientos",
  CuentaContableId: "&CuentaContableId",
  BookingDateLowerLimit: "&BookingDateLowerLimit",
  BookingDateUpperLimit: "&BookingDateUpperLimit",
  AmountLowerLimit: "&AmountLowerLimit",
  AmountUpperLimit: "&AmountUpperLimit",
  Iban: "&iban",
  ImporteMovimiento: "&ImporteMovimiento",
  CamposPersonalizados: "&CamposPersonalizados",
  EmpresaId: "&EmpresaId",
}

const DEBOUNCE_DELAY_TIME = 200

export const debounce = (
  func: $TSMigrationFixMe,
  timeout = DEBOUNCE_DELAY_TIME
) => {
  let timer: $TSMigrationFixMe
  return (...args: $TSMigrationFixMe[]) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(...args)
    }, timeout)
  }
}

export const DOC_TYPE_FORMAT = {
  FACTURA_EDI: 0,
  PEDIDO_EDI: 1,
  ALBARAN_EDI: 2,
  FACTURA_E: 3,
}

export const TRASH_ICON = `${STATIC_ASSETS_URL}/Imagenes/Ilustraciones/Eliminar-modal.svg`
export const PUZZLE_ICON = `${STATIC_ASSETS_URL}/imagenes/ilustraciones/puzzle.svg`
export const INTEGRATIONS_BANNER_IMG = `${STATIC_ASSETS_URL}/imagenes/ilustraciones/img-integraciones-4.svg`
export const SAGE_ICON = `${STATIC_ASSETS_URL}/imagenes/ilustraciones/logos/sage-logo.png`
